export class DiscordAnnualMembershipPrices {
}
DiscordAnnualMembershipPrices.PLUS = 7499;
DiscordAnnualMembershipPrices.PREMIUM = 14999;
DiscordAnnualMembershipPrices.ELITE = 19999;
